import { z } from 'zod'

export const ADMINPERSONAMULTIAGENTGET_CONTRACT_VERSION = '1.0.0' as const
export const adminPersonaMultiAgentGetResponseSchema = z.unknown()
export type AdminPersonaMultiAgentGetResponse = z.infer<typeof adminPersonaMultiAgentGetResponseSchema>
